<template>
  <CCard>      
    <CCardBody>      
      <CRow>  
        <div class="col-lg-12 control-section">
          權限名稱：
          <ejs-dropdownlist  width='200px' allowObjectBinding='true' showClearButton="true"  style="text-align: center;" :dataSource='data' v-model="e_limit_id" :change='onLimitChange' :fields='dropDownFields'  ></ejs-dropdownlist>
          &nbsp;&nbsp;<span v-show="this.e_limit_id != 'add'"><ejs-textbox style="text-align: center;" width='200px' v-model="e_limit_name_update" placeholder="請輸入新名稱" ></ejs-textbox></span>
          &nbsp;&nbsp;<ejs-button v-show="(this.e_limit_id != 'add' && this.e_limit_id != null) && this.limit.indexOf('32') >= 0" :isPrimary="true"  v-on:click.native='update'>修改</ejs-button>
          &nbsp;&nbsp;<ejs-button v-show="(this.e_limit_id != 'add' && this.e_limit_id != null) && this.limit.indexOf('32') >= 0" :isPrimary="true"  v-on:click.native='del'>刪除</ejs-button>   
          &nbsp;&nbsp;<span v-show="this.e_limit_id == 'add'"><ejs-textbox style="text-align: center;" width='200px' v-model="e_limit_name" placeholder="請輸入權限名稱" ></ejs-textbox></span>
          &nbsp;&nbsp;<ejs-button v-show="this.e_limit_id == 'add' && this.limit.indexOf('32') >= 0" :isPrimary="true"  v-on:click.native='add'>新增</ejs-button>   
          
        </div>
      </CRow> 
      <CRow>             
        <CCol sm="2" lg="2" >    
          <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">主控版</div>
          <div id="app">
            <div class="control-section" style="font-size: 15px; border-style:solid; height:600px; overflow:auto;
              border-color: #ced2d8; border-width:0.5px;border-bottom-width:0.5px;">   
              <ejs-treeview ref='workstation' :fields="work" :showCheckBox='true'></ejs-treeview>
            </div>
          </div>  
        </CCol>
        <CCol sm="2" lg="2" >  
          <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">生產作業</div>
          <div id="app">
            <div class="control-section" style="font-size: 15px; border-style:solid; height:600px; overflow:auto;
              border-color: #ced2d8; border-width:0.5px;border-bottom-width:0.5px;">   
              <ejs-treeview ref='production' :fields="production" :showCheckBox='true'></ejs-treeview>
            </div>
          </div>  
        </CCol>
        <CCol sm="2" lg="2" >    
          <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">表單管理</div>
          <div id="app">
            <div class="control-section" style="font-size: 15px; border-style:solid; height:600px; overflow:auto;
              border-color: #ced2d8; border-width:0.5px;border-bottom-width:0.5px;">   
              <ejs-treeview ref='report' :fields="report" :showCheckBox='true'></ejs-treeview>
            </div>
          </div> 
        </CCol>
        <CCol sm="2" lg="2" >   
          <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">供應商管理</div>
          <div id="app">
            <div class="control-section" style="font-size: 15px; border-style:solid; height:600px; overflow:auto;
              border-color: #ced2d8; border-width:0.5px;border-bottom-width:0.5px;">   
              <ejs-treeview ref='scm' :fields="scm" :showCheckBox='true'></ejs-treeview>
            </div>
          </div> 
        </CCol>  
        <CCol sm="2" lg="2" >    
          <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">系統管理</div>
          <div id="app">
            <div class="control-section" style="font-size: 15px; border-style:solid; height:600px; overflow:auto;
              border-color: #ced2d8; border-width:0.5px;border-bottom-width:0.5px;">   
              <ejs-treeview ref='system' :fields="system" :showCheckBox='true'></ejs-treeview>
            </div>
          </div> 
        </CCol>
      </CRow>       
      <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>     
    </CCardBody>   
  </CCard>
</template>

<script>
import Vue from "vue";
import zhtwLocalization  from '../language/language.json';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { TextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { ButtonPlugin  } from '@syncfusion/ej2-vue-buttons';  
import { L10n } from '@syncfusion/ej2-base';  
import { TreeViewComponent } from "@syncfusion/ej2-vue-navigations";

import { DialogUtility } from '@syncfusion/ej2-popups';

L10n.load(zhtwLocalization);
Vue.use(DialogPlugin);
Vue.use(TextBoxPlugin);
Vue.use(TooltipPlugin);
Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);

let DialogObj   = undefined;

export default {
  components: {
    'ejs-toast': ToastComponent,
    "ejs-treeview": TreeViewComponent
  },
  data: function ()  {
    return {
      limit : localStorage.getItem('system'), 
      dropDownFields: { text: 'text', value: 'value' },
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      e_limit_id: null, e_limit_name : null, e_isadd : null,
      e_limit_name_update : null,
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 50 },     
      e_formula_name:null,
      work: { dataSource: [

        { id: 9, name: '主控版', hasChild: true, expanded: true},
        { id: 10, pid: 9, name: '領料', hasChild: true, expanded: true},
        { id: 11, pid: 10, name: '鍋次排程'},
        { id: 12, pid: 10, name: '包裝領料'},
        { id: 13, pid: 10, name: '調理領料'},
        { id: 20, pid: 9, name: '二重釜', hasChild: true, expanded: true },
        { id: 21, pid: 20, name: '建立點料' },
        { id: 22, pid: 20, name: '生產作業' },
        { id: 23, pid: 20, name: '生產返回' },
        { id: 24, pid: 20, name: '生產結束' },
        { id: 30, pid: 9, name: '調理桶', hasChild: true, expanded: true },
        { id: 31, pid: 30, name: '建立點料' },
        { id: 32, pid: 30, name: '調理作業' },
        { id: 33, pid: 30, name: '品檢作業' },
        { id: 34, pid: 30, name: '品檢領料' },
        { id: 35, pid: 30, name: '生產返回' },
        { id: 36, pid: 30, name: '品檢特採' },
        { id: 37, pid: 30, name: '品檢補料' },
        { id: 38, pid: 30, name: '調理結束' },
        { id: 40, pid: 9, name: '充填', hasChild: true, expanded: true },
        { id: 41, pid: 40, name: '充填作業' },
        { id: 42, pid: 40, name: '品檢作業' },
        { id: 43, pid: 40, name: '濾袋' },
        { id: 44, pid: 40, name: 'O型環' },
        { id: 50, pid: 9, name: '包裝', hasChild: true, expanded: true },
        { id: 51, pid: 50, name: '包裝作業' },
        { id: 52, pid: 50, name: '品檢作業' },
        { id: 60, pid: 9, name: '報廢繳庫', hasChild: true, expanded: true },
        { id: 61, pid: 60, name: '報廢作業' },
        { id: 62, pid: 60, name: '成品繳庫' },
      ], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild' },

      production: { dataSource: [
        { id: 9, name: '生產作業', hasChild: true, expanded: true},
        { id: 10, pid: 9, name: '生產排程行事曆', hasChild: true, expanded: true },
        { id: 11, pid: 10, name: '檢視'},
        { id: 12, pid: 10, name: '編輯' },
        { id: 20, pid: 9, name: '配方表管理', hasChild: true, expanded: true },
        { id: 21, pid: 20, name: '檢視' },
        { id: 22, pid: 20, name: '編輯' },
        { id: 30, pid: 9, name: '庫存管理', hasChild: true, expanded: true },
        { id: 31, pid: 30, name: '檢視' },   
        { id: 32, pid: 30, name: '編輯' },
        { id: 40, pid: 9, name: '原醋酸度設定', hasChild: true, expanded: true },
        { id: 41, pid: 40, name: '檢視' },
        { id: 42, pid: 40, name: '編輯' },
        { id: 50, pid: 9, name: '製令補退料', hasChild: true, expanded: true },
        { id: 51, pid: 50, name: '檢視' },
      ], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild' },

      report: { dataSource: [
        { id: 9, name: '表單管理', hasChild: true, expanded: true},
        { id: 10, pid: 9, name: '調理日報表', hasChild: true, expanded: true },
        { id: 11, pid: 10, name: '檢視'},
        { id: 12, pid: 10, name: '製表人簽核'},
        { id: 13, pid: 10, name: '配方覆核簽核'},
        { id: 14, pid: 10, name: '生產組長簽核' },
        { id: 20, pid: 9, name: '生產日報表', hasChild: true, expanded: true },
        { id: 21, pid: 20, name: '檢視' },
        { id: 22, pid: 20, name: '生產組組長簽核'},
        { id: 23, pid: 20, name: '包裝班長簽核' },
        { id: 30, pid: 9, name: '製程檢驗報告單', hasChild: true, expanded: true },
        { id: 31, pid: 30, name: '檢視' },
        { id: 32, pid: 30, name: '生產組組長簽核'},
        { id: 33, pid: 30, name: '班長簽核' },
        { id: 34, pid: 30, name: '主機操作人員簽核' },
        { id: 35, pid: 30, name: '容器領料人員簽核' },
        { id: 36, pid: 30, name: '蓋子領料人員簽核' },
        { id: 40, pid: 9, name: '包裝日報表', hasChild: true, expanded: true },
        { id: 41, pid: 40, name: '檢視' },
        { id: 42, pid: 40, name: '製表人'},
        { id: 43, pid: 40, name: '配方覆核' },
        { id: 50, pid: 9, name: '調理投料管制表', hasChild: true, expanded: true },
        { id: 51, pid: 50, name: '檢視' },
        { id: 52, pid: 50, name: '製表人'},
        { id: 53, pid: 50, name: '配方覆核' },
        { id: 54, pid: 50, name: '生產組組長' },
        { id: 60, pid: 9, name: '濾袋＆Ｏ型環報表單', hasChild: true, expanded: true },
        { id: 61, pid: 60, name: '檢視' },
        { id: 62, pid: 60, name: '生產組組長簽核'},
        { id: 63, pid: 60, name: '班長簽核' },
        { id: 64, pid: 60, name: '主機操作人員簽核' },
        { id: 70, pid: 9, name: '半成品檢驗單', hasChild: true, expanded: true },
        { id: 71, pid: 70, name: '檢視' },
        { id: 72, pid: 70, name: '生產組組長簽核'},
        { id: 73, pid: 70, name: '品保組組長簽核' },
        { id: 74, pid: 70, name: '填表人簽核' },
        { id: 80, pid: 9, name: '生產產能參數', hasChild: true, expanded: true },
        { id: 81, pid: 80, name: '檢視' },
      ], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild' },

      scm: { dataSource: [
        { id: 9, name: '供應商管理', hasChild: true, expanded: true},
        { id: 10, pid: 9, name: '供應商管理', hasChild: true, expanded: true },
        { id: 11, pid: 10, name: '檢視'},
        { id: 12, pid: 10, name: '編輯' },
        { id: 20, pid: 9, name: '供應商評鑑', hasChild: true, expanded: true },
        { id: 21, pid: 20, name: '檢視' },
        { id: 22, pid: 20, name: '評鑑' },
        { id: 30, pid: 9, name: '倉管檢驗', hasChild: true, expanded: true },
        { id: 31, pid: 30, name: '檢視' },
        { id: 32, pid: 30, name: '通知供應商' },
        { id: 33, pid: 30, name: '收料' },
        { id: 34, pid: 30, name: '主管單位簽核' },
        { id: 35, pid: 30, name: '驗收人員簽核' },
        { id: 36, pid: 30, name: '檢查人員簽核' },
        { id: 40, pid: 9, name: '品保檢驗', hasChild: true, expanded: true },
        { id: 41, pid: 40, name: '檢視' },
        { id: 42, pid: 40, name: '編輯' },
        { id: 43, pid: 40, name: '品保組組長簽核' },
        { id: 44, pid: 40, name: '生產組組長簽核' },
        { id: 45, pid: 40, name: '填表人簽核' }
      ], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild' },

      system: { dataSource: [
        { id: 9, name: '系統管理', hasChild: true, expanded: true},
        { id: 10, pid: 9, name: '訊息管理', hasChild: true, expanded: true },
        { id: 11, pid: 10, name: '檢視'},
        { id: 12, pid: 10, name: '編輯' },
        { id: 20, pid: 9, name: '人員管理', hasChild: true, expanded: true },
        { id: 21, pid: 20, name: '檢視' },
        { id: 22, pid: 20, name: '編輯' },
        { id: 30, pid: 9, name: '權限管理', hasChild: true, expanded: true },
        { id: 31, pid: 30, name: '檢視' },
        { id: 32, pid: 30, name: '編輯' },
        { id: 40, pid: 9, name: '收料管理', hasChild: true, expanded: true },
        { id: 41, pid: 40, name: '檢視' },
        { id: 42, pid: 40, name: '編輯' },
        { id: 50, pid: 9, name: '檢驗管理', hasChild: true, expanded: true },
        { id: 51, pid: 50, name: '檢視' },
        { id: 52, pid: 50, name: '編輯' }
      ], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild' },

      data: [],
      filterSettings: { type: 'CheckBox' },
      editSettings: { allowEditing: true, allowAdding: true, allowDeleting: true },
      orderidrules: { required: true, number: true },
      customeridrules: { required: true, minLength: 5 },
      freightrules:  { required: true, min: 0 },
      toolbar: [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' },
        { text: '儲存', tooltipText: '儲存', prefixIcon: 'e-btn-icon e-save e-icons e-icon-left', id: 'Save' },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'CheckItemExport' },
        'Search'
      ],
    };
  },
  created(){
    this.getLimeit(null);
  },
  methods: {
   
    onLimitChange: function() {
      if (this.e_limit_id == null || this.e_limit_id == 'add') {
        this.$refs.workstation.ej2Instances.checkedNodes = [];
        this.$refs.production.ej2Instances.checkedNodes = [];
        this.$refs.report.ej2Instances.checkedNodes = [];
        this.$refs.scm.ej2Instances.checkedNodes = [];
        this.$refs.system.ej2Instances.checkedNodes = [];
        return
      }
      this.axios({
          method:'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url:`/Limit/Detail?id=${this.e_limit_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }
        this.$refs.workstation.ej2Instances.checkedNodes = response.data.datas.workstation || [];
        this.$refs.production.ej2Instances.checkedNodes = response.data.datas.production || [];
        this.$refs.report.ej2Instances.checkedNodes = response.data.datas.report || [];
        this.$refs.scm.ej2Instances.checkedNodes = response.data.datas.scm || [];
        this.$refs.system.ej2Instances.checkedNodes = response.data.datas.system || [];
      })
      .catch((error) => { 
        this.$refs.toastRef.show( { title: '錯誤!', content: error, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
      })
      //this.e_limit_name_update = this.dropDownFields[this.e_limit_id] ;
      console.log(localStorage.getItem(this.e_limit_id));
    },
    add: function() {
      if (this.e_limit_name == null) {
        this.$toast.open({message: "請先新增權限名稱", type: "success", duration: 5000, dismissible: true})   
        return;
      }
      this.e_isadd = true;
      DialogObj = DialogUtility.confirm({
            title: '新增權限',
            content: `確認是否要新增資料嗎?`,
            okButton: {  text: '確認', click: this.addLimitOkConfirmClick },
            cancelButton: {  text: '取消', click: this.addCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
          }); 
    },
    update: function() {
      this.e_isadd = false;
      DialogObj = DialogUtility.confirm({
            title: '修改權限',
            content: `確認是否要修改資料嗎?`,
            okButton: {  text: '確認', click: this.addLimitOkConfirmClick },
            cancelButton: {  text: '取消', click: this.addCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
          }); 
    },
    del: function() {
      this.e_isadd = false;
      DialogObj = DialogUtility.confirm({
            title: '刪除權限',
            content: `確認是否要刪除權限嗎?`,
            okButton: {  text: '確認', click: this.deleteLimitOkConfirmClick },
            cancelButton: {  text: '取消', click: this.addCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
          }); 
    },
    uuid:function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {var r = Math.random()*16|0,v=c=='x'?r:r&0x3|0x8;return v.toString(16);});
    },

    addLimitOkConfirmClick:function(){
      var id = this.uuid();
      this.axios({
          method: this.e_isadd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url:`/Limit`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data: {
            id : this.e_isadd ? id : this.e_limit_id,
            name : this.e_isadd ? this.e_limit_name : this.e_limit_name_update, 
            workstation:this.$refs.workstation.ej2Instances.checkedNodes,
            production:this.$refs.production.ej2Instances.checkedNodes,
            report:this.$refs.report.ej2Instances.checkedNodes,
            scm:this.$refs.scm.ej2Instances.checkedNodes,
            system:this.$refs.system.ej2Instances.checkedNodes
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); DialogObj.hide();  return; }
        this.$refs.toastRef.show( { title: this.e_isadd ? `新增權限成功!` : `修改權限成功!`, content: response.data.msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' }); 
        DialogObj.hide(); 
        this.getLimeit(this.e_isadd ? id : this.e_limit_name_update != "" ? null : this.e_limit_id);
        this.e_limit_name = "";
        this.e_limit_name_update = "";
      })
      .catch((error) => { 
        this.$refs.toastRef.show( { title: '錯誤!', content: error, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
        DialogObj.hide(); 
      })
    },   
    deleteLimitOkConfirmClick:function(){
   
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url:`/Limit/Delete?id=${this.e_limit_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data: {
            id : this.e_limit_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) {
          this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
          DialogObj.hide();
          return;
        }
        this.$refs.toastRef.show( { title: `刪除權限成功!`, content: response.data.msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' }); 
        DialogObj.hide(); 
        this.getLimeit(null);
      })
      .catch((error) => { 
        this.$refs.toastRef.show( { title: '錯誤!', content: error, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
        DialogObj.hide();
      })
    },
    getLimeit(name){
      this.axios({
          method:'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url:'/Limit',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }
        this.data = response.data.datas;
        setTimeout(() => { 
          if (name == null) {
            this.e_limit_id = this.data[0].value;
          } else {
            this.e_limit_id = name;
          }        
        }, 100);        
      })
      .catch((error) => { 
        this.$refs.toastRef.show( { title: '錯誤!', content: error, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
      })
    }   
  },
  provide: {
      
  }
}
</script>
<style lang="scss" src="../../scss/base.scss"></style>